import { Component, ElementRef, OnInit, Renderer2, HostListener } from '@angular/core';

@Component({
  selector: 'app-gotop',
  templateUrl: './gotop.component.html',
  styleUrls: ['./gotop.component.scss']
})
export class GoTopComponent {
  visible = false;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    const scrollTop = event.target.scrollingElement.scrollTop;

    if (scrollTop === 0) {
      this.visible = false;
      // Tu lógica cuando el scroll está en la parte superior
    } else {
      this.visible = true;
      // Otra lógica cuando el scroll no está en la parte superior
    }
  }

  goTop() {
    const element = document.getElementById("top");
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

}
